import { setDraggedItem } from "../Reducers/mileSpaceSlice";
import { ItemsEnum } from "./enum";

export const drawCircle = (canvasRef, position, index, isFirstDot) => {
    if (!canvasRef.current) {
        console.error("Canvas is not yet rendered or canvasRef is not defined.");
        return;
    }

    const ctx = canvasRef.current.getContext('2d');
    if (!ctx) {
        console.error("Failed to get canvas context.");
        return;
    }

    ctx.beginPath();
    ctx.arc(position.x, position.y, 4, 0, 2 * Math.PI);
    ctx.fillStyle = isFirstDot ? 'green' : 'red';
    ctx.fill();
};

export const drawShape = (ctx, positions) => {
    ctx.beginPath();
    positions.forEach((pos, i) => {
        if (i === 0) ctx.moveTo(pos.x, pos.y);
        else ctx.lineTo(pos.x, pos.y);
    });
    ctx.strokeStyle = 'red';
    ctx.lineWidth = 2;
    ctx.stroke();
};

export const isClickInsideShape = (clickPosition, shapePositions) => {
    return isPointInPolygon(clickPosition, shapePositions);
};
export const isClickInsideItem = (clickPosition, item) => {
    const { x, y } = clickPosition;
    const { position, width, height } = item; // Ensure each dropped item has width and height
    return (
        x >= position.x &&
        x <= position.x + width &&
        y >= position.y &&
        y <= position.y + height
    );
};

export const isFirstPosition = (newPos, firstPos) => {
    const tolerance = 10;
    return Math.abs(newPos.x - firstPos.x) < tolerance && Math.abs(newPos.y - firstPos.y) < tolerance;
};

const isPointInPolygon = (point, polygon) => {
    let inside = false;
    for (let i = 0, j = polygon.length - 1; i < polygon.length; j = i++) {
        const xi = polygon[i].x, yi = polygon[i].y;
        const xj = polygon[j].x, yj = polygon[j].y;

        const intersect = ((yi > point.y) !== (yj > point.y)) &&
            (point.x < (xj - xi) * (point.y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
    }
    return inside;
};

export const toBase64 = async (url) => {
    return fetch(url)
        .then((response) => response.blob())
        .then((blob) => {
            return new Promise((resolve, reject) => {
                const reader = new FileReader();
                reader.onloadend = () => resolve(reader.result);
                reader.onerror = reject;
                reader.readAsDataURL(blob);
            });
        });
};

export const getBoundingBox = (positions) => {
    const xs = positions.map(pos => pos.x);
    const ys = positions.map(pos => pos.y);

    return {
        x: Math.min(...xs),
        y: Math.min(...ys),
        width: Math.max(...xs) - Math.min(...xs),
        height: Math.max(...ys) - Math.min(...ys)
    };
};
export const drawDroppedImage = (ctx, itemTitle, dropPosition) => {
    return new Promise((resolve, reject) => {
        const item = ItemsEnum[itemTitle];
        const scaleFactor = 6;

        if (!item) {
            console.error(`Item with title ${itemTitle} not found in ItemsEnum.`);
            reject("Item not found");
            return;
        }

        const img = new Image();
        img.src = item.icon;

        img.onload = () => {
            
            // const scaledWidth = img.width / scaleFactor;
            // const scaledHeight = img.height / scaleFactor;
            const scaledWidth = 12;  
            const scaledHeight = 16.167;
            
            // Draw the mage on the canvas
            ctx.drawImage(
                img,
                dropPosition.x,
                dropPosition.y,
                scaledWidth,
                scaledHeight
            );

            // Return the image data after drawing
            resolve({
                position: { x: dropPosition.x, y: dropPosition.y },
                width: scaledWidth,
                height: scaledHeight,
            });
        };

        img.onerror = () => {
            console.error("Failed to load the image.");
            reject("Image load failed");
        };
    });
};
export const redrawCanvas = (canvasRef, spaceData, dispatch) => {
    if (!canvasRef || !spaceData || !dispatch) {
        return;
    }
    const { backgroundImage, shapes, shapePositions } = spaceData;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, canvas.width, canvas.height);

    if (backgroundImage) {
        const img = new Image();
        img.src = backgroundImage;
        img.onload = () => {
            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);

            shapes.forEach((shape) => {
                drawShape(ctx, shape.positions);
                shape.positions.forEach((pos) => {
                    drawCircle(canvasRef, pos, pos.index + 1, false);
                });

                // Check if the shape has images and draw them at their saved positions
                if (Array.isArray(shape.images) && shape.images.length > 0) {
                    shape.images.forEach((imageData) => {
                        drawDroppedImage(ctx, imageData.title, imageData.position);
                        attachDragListener(canvas, imageData, shape.id, imageData.position, dispatch);
                    });
                }
            });

            if (shapePositions.length > 0) {
                drawShape(ctx, shapePositions);
                shapePositions.forEach((pos, index) => {
                    drawCircle(canvasRef, pos, index + 1, index === 0);
                });
            }
        };
    }
};
export const attachDragListener = (canvas, draggedItem, shapeId, position, dispatch) => {
    // Check if an element is already being dragged and remove it
    const canvasContainer = document.getElementById('my-canvas');
    if (canvasContainer) {
        let existingDragElement = canvasContainer.querySelector(`[data-item-id="${draggedItem.id}"]`);
        if (existingDragElement) {
            existingDragElement.remove();
        }
    }
    const dragElement = document.createElement('div');
    dragElement.style.position = 'absolute';
    dragElement.style.left = `${position.x + canvas.offsetLeft}px`;
    dragElement.style.top = `${position.y + canvas.offsetTop}px`;
    dragElement.style.width = `${draggedItem.width}px`;
    dragElement.style.height = `${draggedItem.height}px`;
    dragElement.draggable = true;
    dragElement.dataset.imageTitle = draggedItem.title;
    dragElement.dataset.itemId = draggedItem.id;

    dragElement.addEventListener('dragstart', () => {
        dispatch(
            setDraggedItem({
                ...draggedItem,
                originatingShapeId: shapeId,
                position,
            })
        );
    });

    canvasContainer.appendChild(dragElement);
};